<template>
	<div class="shipment-search">
		<div class="container ">
			<div class="page-header flex-center">
				<h1 class="page-title">Order Statistic</h1>
			</div>
			<!-- Overviews -->
			<div>
				<div class="d-flex justify-content-between">
					<h6 class="text-bold">Total Order</h6>
					<a href="/admin/orders" class="text-bold" target="_blank">Lihat Detail</a>
				</div>
				<div class="submissions-summaries">
					<overviews
						:overview="overview"
						:layout="'auto'"
						:items="overviewItems.order"
						:capabilities="user.capabilities"
						:source="'order_statistics'"
						:is-fetching="isFetchingStatistic"
					>
					</overviews>
				</div>
			</div>
			<div>
				<div class="d-flex justify-content-between">
					<h6 class="text-bold">Supplier Pending Order</h6>
					<a href="/admin/orders/pending" class="text-bold" target="_blank">Lihat Detail</a>
				</div>
				<div class="submissions-summaries">
					<overviews
						:overview="overview"
						:layout="'auto'"
						:items="overviewItems.supplier"
						:capabilities="user.capabilities"
						:source="'pending'"
						:is-fetching="isFetchingStatistic"
					>
					</overviews>
				</div>
			</div>
			<div>
				<div class="d-flex justify-content-between">
					<h6 class="text-bold">3PL Pending Order</h6>
					<a href="/admin/orders/3pl-pending" class="text-bold" target="_blank">Lihat Detail</a>
				</div>
				<div class="submissions-summaries">
					<overviews
						:overview="overview"
						:layout="'auto'"
						:items="overviewItems.thirdPartyLogistic"
						:capabilities="user.capabilities"
						:source="'3pl-pending'"
						:is-fetching="isFetchingStatistic"
					>
					</overviews>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
	getDateRange,
	generateDateRange,
	duplicateVar,
} from '@/lib/helper';
import statisticApi from '@/api/statistic';
import Overviews from '@/components/Overviews.vue';

const defaultFilterDate = getDateRange();

export default {
	name: 'AdminOrderStatistics',
	props: {
		type: {
			type: String,
			default: 'shipment',
		},
	},
	components: {
		Overviews,
	},
	data() {
		return {
			overviewItems: {
				order: [
					'order_todays',
					'order_weeks',
					'order_months',
				],
				supplier: [
					'supplier_pending_h1',
					'supplier_pending_h2',
					'supplier_pending_h3',
					'supplier_pending_h4',
				],
				thirdPartyLogistic: [
					'third_party_logistic_pending_h1',
					'third_party_logistic_pending_h2',
					'third_party_logistic_pending_h3',
					'third_party_logistic_pending_h4',
				],
			},
			overview: {},
			filterDate: duplicateVar(defaultFilterDate),
		};
	},
	methods: {
		...mapActions({
			fetchUser: 'fetchUser',
		}),
		generateDateRange,
		clearFilter() {
			this.fetchOverviews();
		},
		fetchOverviews() {
			this.isFetchingStatistic = true;
			const params = this.fetchParams;

			const callback = (response) => {
				const statistic = response.data;
				this.overview = statistic;
				this.isFetchingStatistic = false;
			};
			const errorCallback = (e) => {
				console.log(e);
				this.isFetchingStatistic = false;
			};
			statisticApi.calculateStatisticOrder(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			filterDatePresets: 'filterDatePresets',
			isAdmin: 'isAdmin',
			isUserCan: 'isUserCan',
			ordersColumns: 'ordersColumns',
		}),
		fetchParams() {
			const dateFormat = 'YYYY-MM-DD';
			const startDate = this.moment(this.filterDate.start).format(dateFormat);
			const endDate = this.moment(this.filterDate.end).format(dateFormat);

			const params = {
				page: this.page,
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				since: startDate,
				until: endDate,
			};

			return params;
		},
	},
	sockets: {
		update_order(data) {
			const mutator = data?.mutator ? data.mutator : 'increament';
			// for supplier pending there is mutator because when submission processing, supplier still change again to pending
			if (data.type === 'supplier_pending') {
				if (mutator === 'decreament') {
					if (data.diff === 1) {
						this.overview.supplier_pending_h1 -= 1;
					} else if (data.diff === 2) {
						this.overview.supplier_pending_h2 -= 1;
					} else if (data.diff === 3) {
						this.overview.supplier_pending_h3 -= 1;
					} else if (data.diff > 3) {
						this.overview.supplier_pending_h4 -= 1;
					}
				} else if (mutator === 'increament') {
					if (data.diff === 1) {
						this.overview.supplier_pending_h1 += 1;
					} else if (data.diff === 2) {
						this.overview.supplier_pending_h2 += 1;
					} else if (data.diff === 3) {
						this.overview.supplier_pending_h3 += 1;
					} else if (data.diff > 3) {
						this.overview.supplier_pending_h4 += 1;
					}
				}
			} else if (data.type === 'third_party_logistic_pending') {
				if (data.diff === 1) {
					this.overview.third_party_logistic_pending_h1 -= 1;
				} else if (data.diff === 2) {
					this.overview.third_party_logistic_pending_h2 -= 1;
				} else if (data.diff === 3) {
					this.overview.third_party_logistic_pending_h3 -= 1;
				} else if (data.diff > 3) {
					this.overview.third_party_logistic_pending_h4 -= 1;
				}
			}
		},
		create_order() {
			this.overview.order_todays += 1;
			this.overview.order_weeks += 1;
			this.overview.order_months += 1;
		},
		// cancel_order() {
		// 	this.overview.order_todays -= 1;
		// 	this.overview.order_weeks -= 1;
		// 	this.overview.order_months -= 1;
		// },
		calculate_order(data) {
			this.overview.order_todays = data.order_todays;
			this.overview.order_weeks = data.order_weeks;
			this.overview.order_months = data.order_months;

			this.overview.supplier_pending_h1 = data.supplier_pending_h1;
			this.overview.supplier_pending_h2 = data.supplier_pending_h2;
			this.overview.supplier_pending_h3 = data.supplier_pending_h3;
			this.overview.supplier_pending_h4 = data.supplier_pending_h4;

			this.overview.third_party_logistic_pending_h1 = data.third_party_logistic_pending_h1;
			this.overview.third_party_logistic_pending_h2 = data.third_party_logistic_pending_h2;
			this.overview.third_party_logistic_pending_h3 = data.third_party_logistic_pending_h3;
			this.overview.third_party_logistic_pending_h4 = data.third_party_logistic_pending_h4;
		},
	},
	created() {
		this.fetchOverviews();

		// every 4hours will refetch if standby on the page
		setInterval(this.fetchOverviews, 4 * 60 * 60 * 1000);
	},
};
</script>
